import { render, staticRenderFns } from "./successFrom.vue?vue&type=template&id=42788b04&scoped=true&"
import script from "./successFrom.vue?vue&type=script&lang=js&"
export * from "./successFrom.vue?vue&type=script&lang=js&"
import style0 from "./successFrom.vue?vue&type=style&index=0&id=42788b04&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42788b04",
  null
  
)

export default component.exports